import {defineStore} from 'pinia'
import DataSource from "devextreme/data/data_source";
import { ref} from "vue";
import {useDiklatListModel} from "@/stores/models/diklat-list-model";
import _ from "lodash";
export const useDiklatListStore = defineStore(
    'diklatListStore',
    () => {
       
        const isLoading = ref(false);
        const dataSourceDiklatList = ref(
            new DataSource({
                requireTotalCount: true,
                store: useDiklatListModel().diklatListCustomStore,
                filter: null,
                summary: {
                    totalItems: [
                      {
                        column: "biaya",  // The column to summarize
                        summaryType: "sum",        // Supported types: 'sum', 'avg', 'min', 'max', 'count'
                        displayFormat: "Total: {0}", // Format for the total row
                      },

                    ]}
            })
        );

        const onPegawaiChanged = (e) => {
            const selectedPegawai = e.value; // You get the selected date here
            useDiklatListModel().setPegawaiFilter(selectedPegawai);
            dataSourceDiklatList.value.reload();
            
          };

        const getData = async (filter) => {
             useDiklatListModel().setFilter(filter);
             useDiklatListModel().setTake('all');
             await  dataSourceDiklatList.value.reload();
             const totalBiaya = _.sumBy(dataSourceDiklatList.value.items(), item => parseFloat(item.biaya) || 0);
             const result = {
                data: dataSourceDiklatList.value._items,
                totalCount: dataSourceDiklatList.value._items.length,
                summary: [totalBiaya]
            };
             useDiklatListModel().setFilter(null); // reset filter
             return result;

            //  return dataSourceDiklatList.value._items;
        }

       
        const state = ref(true);
        const refresh =()=>{
            
            dataSourceDiklatList.value.reload();
        };

        const initialized = ()=>{ 
            useDiklatListModel().setFilter(null);    
            dataSourceDiklatList.value.reload();
        };

        return {
            dataSourceDiklatList,
            isLoading,
            refresh,
            initialized,
            state,
            onPegawaiChanged,
            getData

        }
    }
);